import React, { useState, useEffect } from "react"
import { Progress } from "antd"

export default ({ seconds, delay, status, ...props }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (seconds && progress < 100) {
      const progressPerSecond = 100 / seconds
      setTimeout(
        () => {
          setProgress(Math.ceil(progress + progressPerSecond / 5))
        },
        progress == 0 ? delay * 1000 + 200 : 200
      )
    }
  })

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {status && status == "exception" ? (
        <div>Datei konnte nicht hochgeladen werden</div>
      ) : null}
      <Progress percent={progress} {...props} status={status} />
    </div>
  )
}
